import React from "react";
import { resource } from "@planzone/dto";

import { Filter } from "@common/filter";
import { useToggle } from "@common/treeToggle";
import { ListToggleArrow } from "@common/listToggleArrow";
import { Context } from "../../context";
import { Resource } from "../resource";
import { GroupIcon } from "../groupIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Group({ group, filter }: Props) {
  const { cell } = React.useContext(Context);
  const { isOpen, toggle } = useToggle(group.uuid, 0, true);

  return (
    <div className={styles.group}>
      <div className={styles.header} style={{ height: cell.height }}>
        <div className={styles.iconBox} onClick={toggle}>
          <ListToggleArrow isOpen={isOpen} />
        </div>
        <GroupIcon className={styles.icon} />
        <h3 className={styles.name}>{group.name}</h3>
      </div>
      {isOpen && (
        <Filter
          filter={filter}
          data={group.workloads}
          extractCriteria={(workLoad) => ({
            resource: {
              ...resource,
              uuid: workLoad.uuid,
              name: workLoad.resourceName,
              profession: workLoad.resourceTitle || "",
              tags: workLoad.resourceTags.map((name) => ({ name })),
            },
          })}
        >
          {(workLoads) => (
            <>
              {workLoads.map((workLoad, index) => (
                <div
                  key={workLoad.uuid}
                  className={styles.resource}
                  style={{ height: cell.height }}
                >
                  <Resource workLoad={workLoad} />
                </div>
              ))}
            </>
          )}
        </Filter>
      )}
    </div>
  );
}

export { Group };
